import { Grid, Typography } from '@mui/material';
import React from 'react';
import useGetIncidentWorkflowStatus from '../../core/api/hooks/incident/useGetIncidentWorkflowStatus';
import { useIncidentReportData } from '../../core/context/IncidentReportDataContext';

function IncidentWorkflowStatus() {
  const { incidentReport } = useIncidentReportData();
  const { data: workflowStatusData, mutate: getWorkflowStatus } = useGetIncidentWorkflowStatus();

  React.useEffect(() => {
    getWorkflowStatus(incidentReport.id!);
  }, [incidentReport]);

  return (
    <Grid container>
      <Grid item xs={2} textAlign="center">
        <Typography variant="caption">Emergency Declared: </Typography>
        <Typography variant="caption" sx={{ fontWeight: 'bold' }}>
          {workflowStatusData?.emergencyDeclared ? 'Yes' : 'No'}
        </Typography>
      </Grid>
      <Grid item xs={2} textAlign="center">
        <Typography variant="caption">Event Review: </Typography>
        <Typography variant="caption" sx={{ fontWeight: 'bold' }}>
          {workflowStatusData?.eventReview ? 'Yes' : 'No'}
        </Typography>
      </Grid>
      <Grid item xs={2} textAlign="center">
        <Typography variant="caption">FAA: </Typography>
        <Typography variant="caption" sx={{ fontWeight: 'bold' }}>
          {workflowStatusData?.faaNotified ? 'Yes' : 'No'}
        </Typography>
      </Grid>
      <Grid item xs={2} textAlign="center">
        <Typography variant="caption">NTSB: </Typography>
        <Typography variant="caption" sx={{ fontWeight: 'bold' }}>
          {workflowStatusData?.ntsbNotified ? 'Yes' : 'No'}
        </Typography>
      </Grid>
      <Grid item xs={2} textAlign="center">
        <Typography variant="caption">AFA: </Typography>
        <Typography variant="caption" sx={{ fontWeight: 'bold' }}>
          {workflowStatusData?.afaNotified ? 'Yes' : 'No'}
        </Typography>
      </Grid>
      <Grid item xs={2} textAlign="center">
        <Typography variant="caption">ALPA: </Typography>
        <Typography variant="caption" sx={{ fontWeight: 'bold' }}>
          {workflowStatusData?.alpanNotified ? 'Yes' : 'No'}
        </Typography>
      </Grid>
    </Grid>
  );
}

export default IncidentWorkflowStatus;
